const { default: axios } = require("axios");

window._routes = [];

$(document).ready(function(){
    init();
});

function init(){

    axios
        .get(window._url + '/routes')
        .then((response) => {

            window._routes = response.data;

        })
        .catch((error) => {

            if(typeof error.response.data.message != 'undefined'){
                messages.error(error.response.data.message);
            } else {
                messages.error(error.response.statusText);
            }
            
        });

}